(() => {
  if (customElements.get('custom-hero')) return;

  class CustomHero extends HTMLElement {
    connectedCallback() {
      const image = this.querySelector('.custom-hero__image');
      if (!image) return;
      const setRatio = () => {
        if (image.naturalWidth && image.naturalHeight) {
          this.style.setProperty('--custom-hero-ratio', `${image.naturalWidth} / ${image.naturalHeight}`);
        }
      };
      if (image.complete) setRatio();
      else image.addEventListener('load', setRatio, { once: true });
    }
  }

  customElements.define('custom-hero', CustomHero);
})();
